const SLIDE_DURATION_MS = 5000;
const ARROW_PAUSE_MS = 8000;

/**
 * Auto-advancing crossfade carousel for the "Who We Are" section. Pauses on hover/focus,
 * pauses for 8s after an arrow click (then resumes unless still hovering), respects
 * prefers-reduced-motion (no auto-advance, arrows/dots still work), and supports multiple
 * instances per page since section blocks can be reused.
 */
function initCarousel(carousel) {
  const slides = Array.from(carousel.querySelectorAll('[data-carousel-slide]'));
  if (slides.length <= 1) return;

  const wrapper = carousel.parentElement;
  const dotsContainer = wrapper?.querySelector('.who-we-are__dots');
  const dots = dotsContainer ? Array.from(dotsContainer.querySelectorAll('[data-carousel-dot]')) : [];
  const prevButton = wrapper?.querySelector('[data-carousel-prev]');
  const nextButton = wrapper?.querySelector('[data-carousel-next]');
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  let index = 0;
  let timer = null;
  let resumeTimer = null;
  let hovering = false;

  function show(nextIndex) {
    slides[index]?.classList.remove('is-active');
    dots[index]?.classList.remove('is-active');
    dots[index]?.setAttribute('aria-selected', 'false');

    index = (nextIndex + slides.length) % slides.length;

    slides[index]?.classList.add('is-active');
    dots[index]?.classList.add('is-active');
    dots[index]?.setAttribute('aria-selected', 'true');
  }

  function start() {
    if (reduceMotion) return;
    stop();
    timer = window.setInterval(() => show(index + 1), SLIDE_DURATION_MS);
  }

  function stop() {
    if (timer) window.clearInterval(timer);
    timer = null;
  }

  /** Pause autoplay, then resume after `ms` — unless the pointer is still hovering. */
  function pauseThenResume(ms) {
    stop();
    if (resumeTimer) window.clearTimeout(resumeTimer);
    resumeTimer = window.setTimeout(() => {
      resumeTimer = null;
      if (!hovering) start();
    }, ms);
  }

  dots.forEach((dot, dotIndex) => {
    dot.addEventListener('click', () => {
      show(dotIndex);
      start();
    });
  });

  prevButton?.addEventListener('click', () => {
    show(index - 1);
    pauseThenResume(ARROW_PAUSE_MS);
  });

  nextButton?.addEventListener('click', () => {
    show(index + 1);
    pauseThenResume(ARROW_PAUSE_MS);
  });

  carousel.addEventListener('mouseenter', () => {
    hovering = true;
    stop();
  });

  carousel.addEventListener('mouseleave', () => {
    hovering = false;
    if (!resumeTimer) start();
  });

  carousel.addEventListener('focusin', stop);
  carousel.addEventListener('focusout', () => {
    if (!resumeTimer) start();
  });

  start();
}

function initAllCarousels() {
  document.querySelectorAll('[data-carousel]').forEach(initCarousel);
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initAllCarousels);
} else {
  initAllCarousels();
}
